<template>
    <span class="animated-flip">
        <span v-for="(digit, index) in displayDigits" :key="index" class="digit-wrapper">
            <span class="digit" :class="{ animate: shouldAnimate }" :style="{ animationDelay: index * stagger + delay + 'ms' }">
                {{ digit }}
            </span>
        </span>
    </span>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";

const props = defineProps({
    value: { type: [Number, String], required: true },
    delay: { type: Number, default: 0 },
    duration: { type: Number, default: 400 },
    stagger: { type: Number, default: 30 },
    startOnMount: { type: Boolean, default: true },
});

const shouldAnimate = ref(false);

const displayDigits = computed(() => {
    // Use spread operator to properly handle emojis and unicode characters
    return [...String(props.value)];
});

const animate = () => {
    shouldAnimate.value = false;
    setTimeout(() => {
        shouldAnimate.value = true;
    }, 10);
};

const reset = () => {
    shouldAnimate.value = false;
};

onMounted(() => {
    if (props.startOnMount) {
        setTimeout(() => {
            animate();
        }, props.delay);
    }
});

watch(
    () => props.value,
    () => {
        if (props.startOnMount) {
            animate();
        }
    },
);

defineExpose({ animate, reset });
</script>

<style scoped>
.animated-flip {
    display: inline-flex;
}

.digit-wrapper {
    display: inline-block;
    overflow: hidden;
    perspective: 500px;
    white-space: pre;
}

.digit {
    display: inline-block;
    opacity: 0;
    transform: rotateX(-90deg);
    transform-origin: center bottom;
}

.digit.animate {
    animation: flipIn v-bind('duration + "ms"') cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes flipIn {
    0% {
        opacity: 0;
        transform: rotateX(-90deg);
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 1;
        transform: rotateX(0);
    }
}
</style>
